export const namespaced = true;

export const state = {
    videos: [],
    errors: null,
    loading: false,
}

export const mutations = {
    FETCH(state, videos) {
        state.videos = videos;
    },

    ADD_TEMP_VIDEO(state, newVideo) {
        state.videos = [...state.videos, newVideo];
    },

    REMOVE_TEMP_VIDEO(state, tempId) {
        state.videos = state.videos.filter(v => !v.tempId || v.tempId != tempId);
    },
}

export const actions = {

    async fetch({ commit, dispatch }) {
        try {
            const res = await axios.get(`/api/admin/video-instructions`);
            commit('FETCH', res.data);
            return res.data;
        } catch (error) {
            const notification = {
                page: 'error',
                message: error.response && error.response.data && error.response.data.message
            }
            dispatch('notification/add', notification, { root: true })
        }
    },


    async save({ dispatch }, item) {
        try {
            if (item.id) {
                await axios.patch(`/api/admin/video-instructions/${item.id}`, item);
            } else {
                await axios.post(`/api/admin/video-instructions`, item);
            }
            const notification = {
                type: "success",
                message: "Сохранение прошло успешно",
            };
            dispatch("notification/add", notification, { root: true });
            dispatch('fetch');
        } catch (e) {
            throw e;
        }
    },




    async remove({ dispatch, commit }, video) {
        if (video.id) {
            try {
                await axios.delete(`/api/admin/video-instructions/${video.id}`);
                dispatch('fetch');
            } catch (e) {
                throw e;
            }
        } else if (video.tempId) {
            commit('REMOVE_TEMP_VIDEO', video.tempId)
        }

    },

    addTempVideo({ commit }, newVideo) {
        commit('ADD_TEMP_VIDEO', newVideo)
    }

}
